import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import NavBar from './navbar';
import Footer from './footer';
import UserService from '../service/user.service';

const BACKEND_URL = process.env.REACT_APP_BACKEND_ROOT || 'https://wesdasdasda.online/escort_api/';

function getRandomTwoDigit() {
    return Math.floor(Math.random() * 100).toString().padStart(2, '0');
}

export default function OrderComponent({ setOrderData, user }) {
    const { id } = useParams();
    const history = useHistory();
    const [model, setModel] = useState(null);
    const [visitType, setVisitType] = useState('home'); // home | out
    const [address, setAddress] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [priceType, setPriceType] = useState('');
    const [promo, setPromo] = useState('');
    const [discount, setDiscount] = useState(0);
    const [promoStatus, setPromoStatus] = useState(null); // 'ok' | 'err' | null
    const [errMsg, setErrMsg] = useState('');

    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        UserService.getSimpleModel(id, user.id).then(r => setModel(r.data));
    }, [id]);

    function handlePromoChange(e) {
        const val = e.target.value;
        setPromo(val);
        if (val.length >= 4 && val.length <= 8) {
            UserService.findPromo(val).then(r => {
                if (r.data) {
                    setDiscount(r.data.discount);
                    setPromoStatus('ok');
                } else {
                    setDiscount(0);
                    setPromoStatus('err');
                }
            });
        } else {
            setDiscount(0);
            setPromoStatus(null);
        }
    }

    function validate() {
        const msgs = [];
        if (visitType === 'out' && !address.trim()) msgs.push('Укажите адрес');
        if (!date) msgs.push('Выберите дату');
        if (!time) msgs.push('Выберите время');
        if (!priceType) msgs.push('Выберите тип оплаты');
        return msgs;
    }

    function submit() {
        const errors = validate();
        if (errors.length) { setErrMsg(errors.join('\n')); return; }
        setErrMsg('');

        const priceMap = {
            'Час': visitType === 'out' ? model.out_hour : model.home_hour,
            'Евро час': visitType === 'out' ? model.out_ehour : model.home_ehour,
            'Ночь': visitType === 'out' ? model.out_night : model.home_night,
        };
        let price = priceMap[priceType] || 0;
        if (discount) price -= Math.round((price * discount) / 100);

        setOrderData({
            name: model.name,
            date: date + ' ' + time,
            adress: address,
            price: price + '.' + getRandomTwoDigit(),
            model_id: model.id,
        });
        history.push('/payment');
    }

    if (!model) return (
        <>
            <NavBar text="Оформление заказа" />
            <div style={{ paddingTop: 70, padding: '70px 16px' }}>
                <div className="skeleton" style={{ height: 80, borderRadius: 12 }} />
            </div>
        </>
    );

    return (
        <>
            <NavBar text="Оформление заказа" />
            <div className="order-page">
                <div className="order-model-preview">
                    {model.image_url && (
                        <img src={`${BACKEND_URL}uploads/${model.image_url}`} alt={model.name} />
                    )}
                    <div>
                        <div className="model-name">{model.name}</div>
                        <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{model.age} лет</div>
                    </div>
                </div>

                <div>
                    <div className="order-section-label">Тип визита</div>
                    <div className="seg-control">
                        <button className={`seg-option${visitType === 'home' ? ' active' : ''}`} onClick={() => setVisitType('home')}>На дом</button>
                        <button className={`seg-option${visitType === 'out' ? ' active' : ''}`} onClick={() => setVisitType('out')}>Выезд</button>
                    </div>
                </div>

                {visitType === 'out' && (
                    <div>
                        <div className="order-section-label">Адрес</div>
                        <input className="input-field" placeholder="Укажите адрес" value={address} onChange={e => setAddress(e.target.value)} />
                    </div>
                )}

                <div>
                    <div className="order-section-label">Дата и время</div>
                    <div className="datetime-row">
                        <input className="input-field" type="date" value={date} min={today} onChange={e => setDate(e.target.value)} />
                        <input className="input-field" type="time" value={time} onChange={e => setTime(e.target.value)} />
                    </div>
                </div>

                <div>
                    <div className="order-section-label">Тип оплаты</div>
                    <div className="seg-control">
                        <button className={`seg-option${priceType === 'Евро час' ? ' active' : ''}`} onClick={() => setPriceType('Евро час')}>Евро час</button>
                        <button className={`seg-option${priceType === 'Час' ? ' active' : ''}`} onClick={() => setPriceType('Час')}>Час</button>
                        <button className={`seg-option${priceType === 'Ночь' ? ' active' : ''}`} onClick={() => setPriceType('Ночь')}>Ночь</button>
                    </div>
                </div>

                <div>
                    <div className="order-section-label">Промокод (необязательно)</div>
                    <input className="input-field" placeholder="Введите промокод" value={promo} onChange={handlePromoChange} />
                    {promoStatus === 'ok' && <div className="promo-status ok">Скидка {discount}%</div>}
                    {promoStatus === 'err' && <div className="promo-status err">Промокод не найден</div>}
                </div>

                {errMsg && (
                    <div style={{ background: '#FEF2F2', border: '1px solid var(--red)', borderRadius: 10, padding: '10px 14px' }}>
                        {errMsg.split('\n').map((m, i) => <div key={i} style={{ fontSize: 13, color: 'var(--red)' }}>{m}</div>)}
                    </div>
                )}

                <button className="btn-primary" onClick={submit}>Оформить заказ</button>
            </div>
            <Footer />
        </>
    );
}
